import gql from 'graphql-tag';
import { textPairFragment } from '../../query/fragments';

/**
 * @name ACCOUNT_PAGES_NAV_QUERY
 * @description GraphQL query to fetch user authentication state to determine which left navigation to render
 * @public
 */
export const ACCOUNT_PAGES_NAV_QUERY = gql`
  query ACCOUNT_PAGES_NAV_QUERY {
    userState { 
      isLoggedIn 
    }
  }
`;

/**
 * @name LOGGED_OUT_LEFT_NAV_QUERY
 * @description GraphQL query to fetch text content and configuration for logged out left navigation
 * @public
 */
export const LOGGED_OUT_LEFT_NAV_QUERY = gql`
  query LOGGED_OUT_LEFT_NAV_QUERY {
    textFor {
      guestNavText: pair(pairKey: "guestNavText") { ...textPair }
      helpText: pair(pairKey: "helpText") { ...textPair }
      signInText: pair(pairKey: "signIn") { ...textPair }
    }
    config {
      enableMFEAuthenticationModal: bool(name: "enableMFEAuthenticationModal")
      helpPageUrl: string(name: "helpPageUrl")
    }
  }

  ${textPairFragment}
`;

/**
 * @name LOGGED_IN_LEFT_NAV_QUERY
 * @description GraphQL query to fetch navigation links for logged in users
 * @public
 */
export const LOGGED_IN_LEFT_NAV_QUERY = gql`
  query LOGGED_IN_LEFT_NAV_QUERY {
    textFor {
      navLinks: listField(fieldKey: "leftNavLinks") { ...linkListValues }
    }
  }

  fragment linkListValues on FieldOptionList {
    label { ...textPair }
    options {
      url: optionValue
      text {...textPair}
    }
  }

  ${textPairFragment}
`;

/**
 * @name LOGGED_IN_LEFT_NAV_NON_CACHED_QUERY
 * @description GraphQL query to fetch non-cached user-specific data for logged in left navigation (welcome message, loyalty info)
 * @public
 */
export const LOGGED_IN_LEFT_NAV_NON_CACHED_QUERY = gql`
  query LOGGED_IN_LEFT_NAV_NON_CACHED_QUERY {
    textFor {
      welcomeMessageText: nonCachedPair(pairKey: "welcomeMessage") { ...textPair }
      memberSinceText: nonCachedPair(pairKey: "loyaltyMemberSinceMessage") { ...textPair }
      loyaltyTierImageAltText: pair(pairKey: "loyaltyTierLogoLabel") {...textPair}
    }
    config {
      loyaltyTierImageSrc: nonCachedString(name: "loyaltyTierImageUrl")
    }
  }

  ${textPairFragment}
`;
